import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import kebabCase from 'lodash/kebabCase'
import Link from 'gatsby-link'
import compose from 'recompose/compose'
import Chip from '@material-ui/core/Chip'
import Badge from '@material-ui/core/Badge'
import withStyles from '@material-ui/core/styles/withStyles'

const styles = (theme) => ({
  tag: {
    background: theme.palette.primary.main,
    paddingRight: 2,
    color: '#fff',
    cursor: 'pointer',
    margin: theme.spacing.unit / 5,
    '&:hover': {
      color: theme.palette.primary.dark,
      background: theme.palette.borders.ghost,
    },
    [theme.breakpoints.only('xs')]: {
      fontSize: '0.7em',
      height: 25,
    },
  },
  badge: {
    marginLeft: 15,
  },
  badgeCounter: {
    color: theme.palette.primary.main,
    background: '#fff',
  },
})

export function Tag({ tag, ...props }) {
  return <Chip component={Link} to={`/tags/${kebabCase(tag)}`} {...props} />
}

function Tags({ classes, tags, counter }) {
  return tags
    ? tags.map((tag, i) => (
        <Tag
          key={`tag-chip${i}${tag}`}
          label={
            counter ? (
              <Typography>
                {tag}
                <Badge
                  color="primary"
                  badgeContent={counter[tag]}
                  classes={{
                    root: classes.badge,
                    colorPrimary: classes.badgeCounter,
                  }}
                  children=""
                />
              </Typography>
            ) : (
              <span>{tag}</span>
            )
          }
          className={classes.tag}
          tag={tag}
        />
      ))
    : null
}

Tags.propTypes = {
  classes: PropTypes.object.isRequired,
  tags: PropTypes.arrayOf(PropTypes.string),
  counter: PropTypes.object,
}

// prettier-ignore
export default compose(
  withStyles(styles),
)(Tags)



// WEBPACK FOOTER //
// ./src/components/Tags.js